module.exports = __webpack_public_path__ + "assets/images/glassShade-02.3c212c17d9f6ccb4a6fab9c8c11b8e9f.svg";